import { createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, vModelRadio as _vModelRadio, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "create-template-block" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "row" }, [
  /*#__PURE__*/_createVNode("div", { class: "col-lg-9 offset-lg-3" }, [
    /*#__PURE__*/_createVNode("div", { class: "inner-wrap pt-0" }, [
      /*#__PURE__*/_createVNode("h1", { class: "title" }, "create form")
    ])
  ])
], -1)
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-3" }
const _hoisted_5 = { class: "form-element-wrapper block-list" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Section ")
const _hoisted_7 = /*#__PURE__*/_createVNode("a", { href: "javascript:void(0)" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" })
], -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Text field ")
const _hoisted_9 = /*#__PURE__*/_createVNode("a", { href: "javascript:void(0)" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" })
], -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Textarea ")
const _hoisted_11 = /*#__PURE__*/_createVNode("a", { href: "javascript:void(0)" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" })
], -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Select ")
const _hoisted_13 = /*#__PURE__*/_createVNode("a", { href: "javascript:void(0)" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" })
], -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Radio ")
const _hoisted_15 = /*#__PURE__*/_createVNode("a", { href: "javascript:void(0)" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" })
], -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" checkbox ")
const _hoisted_17 = /*#__PURE__*/_createVNode("a", { href: "javascript:void(0)" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" })
], -1)
const _hoisted_18 = { class: "col-lg-9" }
const _hoisted_19 = { class: "card drag-wrapper" }
const _hoisted_20 = { class: "form-wrap pt-0" }
const _hoisted_21 = { class: "form-block" }
const _hoisted_22 = { class: "form-group" }
const _hoisted_23 = { class: "edit-action" }
const _hoisted_24 = /*#__PURE__*/_createVNode("i", { class: "fas fa-pencil-alt" }, null, -1)
const _hoisted_25 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Name of the Form", -1)
const _hoisted_26 = { class: "form-group mb-0" }
const _hoisted_27 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Short Description", -1)
const _hoisted_28 = {
  key: 0,
  class: "card drag-wrapper"
}
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { class: "form-block form-title" }
const _hoisted_31 = { class: "edit-action" }
const _hoisted_32 = /*#__PURE__*/_createVNode("i", { class: "fas fa-pencil-alt" }, null, -1)
const _hoisted_33 = /*#__PURE__*/_createVNode("i", { class: "fas fa-trash-alt" }, null, -1)
const _hoisted_34 = { class: "title" }
const _hoisted_35 = { class: "form-wrap pt-0" }
const _hoisted_36 = {
  key: 0,
  class: "form-block"
}
const _hoisted_37 = { class: "form-group mb-0" }
const _hoisted_38 = { class: "edit-action" }
const _hoisted_39 = /*#__PURE__*/_createVNode("i", { class: "fas fa-pencil-alt" }, null, -1)
const _hoisted_40 = /*#__PURE__*/_createVNode("i", { class: "fas fa-trash-alt" }, null, -1)
const _hoisted_41 = { for: "inputPassword" }
const _hoisted_42 = {
  key: 1,
  class: "form-block"
}
const _hoisted_43 = { class: "form-group mb-0" }
const _hoisted_44 = { class: "edit-action" }
const _hoisted_45 = /*#__PURE__*/_createVNode("i", { class: "fas fa-pencil-alt" }, null, -1)
const _hoisted_46 = /*#__PURE__*/_createVNode("i", { class: "fas fa-trash-alt" }, null, -1)
const _hoisted_47 = { for: "inputPassword" }
const _hoisted_48 = {
  key: 2,
  class: "form-block"
}
const _hoisted_49 = { class: "edit-action" }
const _hoisted_50 = /*#__PURE__*/_createVNode("i", { class: "fas fa-pencil-alt" }, null, -1)
const _hoisted_51 = /*#__PURE__*/_createVNode("i", { class: "fas fa-trash-alt" }, null, -1)
const _hoisted_52 = { class: "d-inline-block ml-2 mb-0" }
const _hoisted_53 = {
  key: 3,
  class: "form-block"
}
const _hoisted_54 = { class: "form-wrap pt-0" }
const _hoisted_55 = { class: "edit-action" }
const _hoisted_56 = /*#__PURE__*/_createVNode("i", { class: "fas fa-pencil-alt" }, null, -1)
const _hoisted_57 = /*#__PURE__*/_createVNode("i", { class: "fas fa-trash-alt" }, null, -1)
const _hoisted_58 = { for: "" }
const _hoisted_59 = {
  class: "custom-control-label",
  for: "customRadioInline1"
}
const _hoisted_60 = {
  key: 4,
  class: "form-block"
}
const _hoisted_61 = { class: "edit-action" }
const _hoisted_62 = /*#__PURE__*/_createVNode("i", { class: "fas fa-pencil-alt" }, null, -1)
const _hoisted_63 = /*#__PURE__*/_createVNode("i", { class: "fas fa-trash-alt" }, null, -1)
const _hoisted_64 = { for: "" }
const _hoisted_65 = {
  id: "cars",
  class: "form-control"
}
const _hoisted_66 = { class: "form-title" }
const _hoisted_67 = { key: 1 }
const _hoisted_68 = /*#__PURE__*/_createVNode("p", null, "Add Elements from Left side and Create New Form", -1)
const _hoisted_69 = { class: "modal-wrap form-edit" }
const _hoisted_70 = {
  class: "modal fade",
  id: "beforeAdd",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_71 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_72 = { class: "modal-content" }
const _hoisted_73 = { class: "modal-header" }
const _hoisted_74 = {
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_75 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "close",
  "data-dismiss": "modal",
  "aria-label": "Close"
}, [
  /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×")
], -1)
const _hoisted_76 = { class: "modal-body" }
const _hoisted_77 = { class: "form-wrap pt-0" }
const _hoisted_78 = { key: 0 }
const _hoisted_79 = { class: "form-group" }
const _hoisted_80 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Title", -1)
const _hoisted_81 = { class: "form-group" }
const _hoisted_82 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Description", -1)
const _hoisted_83 = { key: 1 }
const _hoisted_84 = { class: "form-group" }
const _hoisted_85 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Title", -1)
const _hoisted_86 = { key: 2 }
const _hoisted_87 = { class: "form-group" }
const _hoisted_88 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Title", -1)
const _hoisted_89 = { key: 3 }
const _hoisted_90 = { class: "form-wrap pt-0" }
const _hoisted_91 = { class: "form-group" }
const _hoisted_92 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Title", -1)
const _hoisted_93 = {
  key: 0,
  class: "form-group"
}
const _hoisted_94 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Options", -1)
const _hoisted_95 = { class: "col-lg-1" }
const _hoisted_96 = { class: "form-check" }
const _hoisted_97 = { class: "col-lg-5" }
const _hoisted_98 = { class: "col-lg-5" }
const _hoisted_99 = { class: "col-lg-1 pl-0" }
const _hoisted_100 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_101 = { class: "text-right" }
const _hoisted_102 = /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_103 = /*#__PURE__*/_createTextVNode(" Add option")
const _hoisted_104 = { key: 4 }
const _hoisted_105 = { class: "form-wrap pt-0" }
const _hoisted_106 = { class: "form-group" }
const _hoisted_107 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Title", -1)
const _hoisted_108 = {
  key: 0,
  class: "form-group"
}
const _hoisted_109 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Options", -1)
const _hoisted_110 = { class: "col-lg-1" }
const _hoisted_111 = { class: "form-check" }
const _hoisted_112 = { class: "col-lg-5" }
const _hoisted_113 = { class: "col-lg-5" }
const _hoisted_114 = { class: "col-lg-1 pl-0" }
const _hoisted_115 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_116 = { class: "text-right" }
const _hoisted_117 = /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_118 = /*#__PURE__*/_createTextVNode(" Add option")
const _hoisted_119 = { key: 5 }
const _hoisted_120 = { class: "form-wrap pt-0" }
const _hoisted_121 = { class: "form-group" }
const _hoisted_122 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Title", -1)
const _hoisted_123 = {
  key: 0,
  class: "form-group"
}
const _hoisted_124 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Options", -1)
const _hoisted_125 = { class: "col-lg-1" }
const _hoisted_126 = { class: "form-check" }
const _hoisted_127 = { class: "col-lg-5" }
const _hoisted_128 = { class: "col-lg-5" }
const _hoisted_129 = { class: "col-lg-1 pl-0" }
const _hoisted_130 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_131 = { class: "text-right" }
const _hoisted_132 = /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_133 = /*#__PURE__*/_createTextVNode(" Add option")
const _hoisted_134 = { class: "form-group" }
const _hoisted_135 = /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Add at", -1)
const _hoisted_136 = /*#__PURE__*/_createVNode("option", { selected: "" }, "Select", -1)
const _hoisted_137 = /*#__PURE__*/_createVNode("option", { value: "top" }, "Top", -1)
const _hoisted_138 = /*#__PURE__*/_createVNode("option", { value: "bottom" }, "Bottom", -1)
const _hoisted_139 = { class: "modal-footer" }
const _hoisted_140 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "btn secondary-btn",
  "data-dismiss": "modal"
}, " Close ", -1)
const _hoisted_141 = /*#__PURE__*/_createVNode("div", { class: "modal-wrap form-edit" }, [
  /*#__PURE__*/_createVNode("div", {
    class: "modal fade",
    id: "edittext",
    tabindex: "-1",
    role: "dialog",
    "aria-labelledby": "exampleModalLabel",
    "aria-hidden": "true"
  }, [
    /*#__PURE__*/_createVNode("div", {
      class: "modal-dialog modal-dialog-centered",
      role: "document"
    }, [
      /*#__PURE__*/_createVNode("div", { class: "modal-content" }, [
        /*#__PURE__*/_createVNode("div", { class: "modal-header" }, [
          /*#__PURE__*/_createVNode("h5", {
            class: "modal-title",
            id: "exampleModalLabel"
          }, "Edit form"),
          /*#__PURE__*/_createVNode("button", {
            type: "button",
            class: "close",
            "data-dismiss": "modal",
            "aria-label": "Close"
          }, [
            /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×")
          ])
        ]),
        /*#__PURE__*/_createVNode("div", { class: "modal-body" }, [
          /*#__PURE__*/_createVNode("div", { class: "form-wrap pt-0" }, [
            /*#__PURE__*/_createVNode("div", { class: "form-group" }, [
              /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Label"),
              /*#__PURE__*/_createVNode("input", {
                type: "text",
                class: "form-control",
                id: "inputPassword",
                placeholder: "Text field label",
                value: "How Long Would It Take To Complete This Task?"
              })
            ]),
            /*#__PURE__*/_createVNode("div", { class: "form-group" }, [
              /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Type"),
              /*#__PURE__*/_createVNode("select", { class: "form-control custom-select" }, [
                /*#__PURE__*/_createVNode("option", { selected: "" }, "Select"),
                /*#__PURE__*/_createVNode("option", { value: "1" }, "Textfield"),
                /*#__PURE__*/_createVNode("option", { value: "2" }, "Password"),
                /*#__PURE__*/_createVNode("option", { value: "3" }, "Email")
              ])
            ]),
            /*#__PURE__*/_createVNode("div", { class: "form-group" }, [
              /*#__PURE__*/_createVNode("label", { for: "inputPassword" }, "Max length"),
              /*#__PURE__*/_createVNode("input", {
                type: "password",
                class: "form-control",
                id: "inputPassword",
                placeholder: "Text field label"
              })
            ])
          ])
        ]),
        /*#__PURE__*/_createVNode("div", { class: "modal-footer" }, [
          /*#__PURE__*/_createVNode("button", {
            type: "button",
            class: "btn secondary-btn",
            "data-dismiss": "modal"
          }, " Close "),
          /*#__PURE__*/_createVNode("button", {
            type: "button",
            class: "btn default-btn"
          }, " Save changes ")
        ])
      ])
    ])
  ])
], -1)
const _hoisted_142 = { class: "modal-wrap form-edit" }
const _hoisted_143 = {
  class: "modal fade",
  id: "deleteSelectedElementInCreateNewForm",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_144 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_145 = { class: "modal-content" }
const _hoisted_146 = { class: "modal-header" }
const _hoisted_147 = /*#__PURE__*/_createVNode("h5", {
  class: "modal-title",
  id: "exampleModalLabel"
}, " Delete Confirmation ", -1)
const _hoisted_148 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_149 = /*#__PURE__*/_createVNode("div", { class: "modal-body" }, [
  /*#__PURE__*/_createVNode("div", { class: "form-wrap pt-0" }, [
    /*#__PURE__*/_createVNode("p", null, "Are you sure you want to delete following form item?")
  ])
], -1)
const _hoisted_150 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("ul", null, [
              _createVNode("li", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showTextFieldAdd('title', 'Section')))
              }, [
                _hoisted_6,
                _hoisted_7
              ]),
              _createVNode("li", {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showTextFieldAdd('textbox', 'Text Box')))
              }, [
                _hoisted_8,
                _hoisted_9
              ]),
              _createVNode("li", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showTextFieldAdd('textArea', 'TextArea')))
              }, [
                _hoisted_10,
                _hoisted_11
              ]),
              _createVNode("li", {
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showTextFieldAdd('single_select', 'Select Option')))
              }, [
                _hoisted_12,
                _hoisted_13
              ]),
              _createVNode("li", {
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showTextFieldAdd('radioButton', 'Radio Button')))
              }, [
                _hoisted_14,
                _hoisted_15
              ]),
              _createVNode("li", {
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showTextFieldAdd('checkBox', 'Check Box')))
              }, [
                _hoisted_16,
                _hoisted_17
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_18, [
          _createVNode("div", _hoisted_19, [
            _createVNode("div", _hoisted_20, [
              _createVNode("div", _hoisted_21, [
                _createVNode("div", _hoisted_22, [
                  _createVNode("div", _hoisted_23, [
                    (
                        _ctx.state.newFormData.title &&
                          _ctx.state.newFormData.title.length
                      )
                      ? (_openBlock(), _createBlock("a", {
                          key: 0,
                          href: "javascript:void(0)",
                          "data-toggle": "modal",
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showNewTitleInCreateFormEdit('title')))
                        }, [
                          _hoisted_24
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _hoisted_25,
                  _withDirectives(_createVNode("input", {
                    type: "text",
                    class: "form-control",
                    id: "inputPassword",
                    placeholder: "Title Here",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.state.newFormData.title = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.state.newFormData.title]
                  ])
                ]),
                _createVNode("div", _hoisted_26, [
                  _hoisted_27,
                  _withDirectives(_createVNode("input", {
                    type: "text",
                    class: "form-control",
                    id: "inputPassword",
                    placeholder: "Description here",
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.state.newFormData.description = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.state.newFormData.description]
                  ])
                ])
              ])
            ])
          ]),
          (_ctx.state.data && _ctx.state.data.length)
            ? (_openBlock(), _createBlock("div", _hoisted_28, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data, (form, formIndex) => {
                  return (_openBlock(), _createBlock("div", { key: formIndex }, [
                    (form.type === 'title')
                      ? (_openBlock(), _createBlock("div", _hoisted_29, [
                          _createVNode("div", _hoisted_30, [
                            _createVNode("div", _hoisted_31, [
                              _createVNode("a", {
                                href: "javascript:void(0)",
                                "data-toggle": "modal",
                                onClick: ($event: any) => (_ctx.showNewElementEdit(form, 'title'))
                              }, [
                                _hoisted_32
                              ], 8, ["onClick"]),
                              _createVNode("a", {
                                href: "javascript:void(0)",
                                class: "trash",
                                onClick: ($event: any) => (_ctx.showNewElementDelete(form, 'title'))
                              }, [
                                _hoisted_33
                              ], 8, ["onClick"])
                            ]),
                            _createVNode("h3", _hoisted_34, _toDisplayString(form.title), 1),
                            _createVNode("h5", null, _toDisplayString(form.description), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode("div", _hoisted_35, [
                      (form.type === 'textbox')
                        ? (_openBlock(), _createBlock("div", _hoisted_36, [
                            _createVNode("div", _hoisted_37, [
                              _createVNode("div", _hoisted_38, [
                                _createVNode("a", {
                                  href: "javascript:void(0)",
                                  "data-toggle": "modal",
                                  onClick: ($event: any) => (_ctx.showNewElementEdit(form, 'textbox'))
                                }, [
                                  _hoisted_39
                                ], 8, ["onClick"]),
                                _createVNode("a", {
                                  href: "javascript:void(0)",
                                  class: "trash",
                                  onClick: ($event: any) => (_ctx.showNewElementDelete(form, 'textbox'))
                                }, [
                                  _hoisted_40
                                ], 8, ["onClick"])
                              ]),
                              _createVNode("label", _hoisted_41, _toDisplayString(form.title), 1),
                              _withDirectives(_createVNode("input", {
                                readonly: "",
                                "onUpdate:modelValue": ($event: any) => (form.answer = $event),
                                type: "text",
                                class: "form-control",
                                id: "inputPassword",
                                placeholder: "Title Here"
                              }, null, 8, ["onUpdate:modelValue"]), [
                                [_vModelText, form.answer]
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (form.type === 'textArea')
                        ? (_openBlock(), _createBlock("div", _hoisted_42, [
                            _createVNode("div", _hoisted_43, [
                              _createVNode("div", _hoisted_44, [
                                _createVNode("a", {
                                  href: "javascript:void(0)",
                                  "data-toggle": "modal",
                                  onClick: ($event: any) => (_ctx.showNewElementEdit(form, 'textArea'))
                                }, [
                                  _hoisted_45
                                ], 8, ["onClick"]),
                                _createVNode("a", {
                                  href: "javascript:void(0)",
                                  class: "trash",
                                  onClick: ($event: any) => (_ctx.showNewElementDelete(form, 'textArea'))
                                }, [
                                  _hoisted_46
                                ], 8, ["onClick"])
                              ]),
                              _createVNode("label", _hoisted_47, _toDisplayString(form.title), 1),
                              _withDirectives(_createVNode("input", {
                                readonly: "",
                                "onUpdate:modelValue": ($event: any) => (form.answer = $event),
                                type: "text",
                                class: "form-control",
                                id: "inputPassword",
                                placeholder: "Title Here"
                              }, null, 8, ["onUpdate:modelValue"]), [
                                [_vModelText, form.answer]
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (form.type === 'checkBox')
                        ? (_openBlock(), _createBlock("div", _hoisted_48, [
                            _createVNode("div", _hoisted_49, [
                              _createVNode("a", {
                                href: "javascript:void(0)",
                                "data-toggle": "modal",
                                onClick: ($event: any) => (_ctx.showNewElementEdit(form, 'checkBox'))
                              }, [
                                _hoisted_50
                              ], 8, ["onClick"]),
                              _createVNode("a", {
                                href: "javascript:void(0)",
                                class: "trash",
                                onClick: ($event: any) => (_ctx.showNewElementDelete(form, 'checkBox'))
                              }, [
                                _hoisted_51
                              ], 8, ["onClick"])
                            ]),
                            _createVNode("label", null, _toDisplayString(form.title), 1),
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(form.select_values, (option, optionIndex) => {
                              return (_openBlock(), _createBlock("div", {
                                class: "form-check form-check-inline",
                                key: optionIndex
                              }, [
                                _withDirectives(_createVNode("input", {
                                  disabled: "",
                                  type: "checkbox",
                                  id: "vehicle1",
                                  name: "vehicle1",
                                  value: option.text,
                                  "onUpdate:modelValue": ($event: any) => (option.selected = $event)
                                }, null, 8, ["value", "onUpdate:modelValue"]), [
                                  [_vModelCheckbox, option.selected]
                                ]),
                                _createVNode("label", _hoisted_52, _toDisplayString(option.text), 1)
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      (form.type === 'radioButton')
                        ? (_openBlock(), _createBlock("div", _hoisted_53, [
                            _createVNode("div", _hoisted_54, [
                              _createVNode("div", _hoisted_55, [
                                _createVNode("a", {
                                  href: "javascript:void(0)",
                                  "data-toggle": "modal",
                                  onClick: ($event: any) => (_ctx.showNewElementEdit(form, 'radioButton'))
                                }, [
                                  _hoisted_56
                                ], 8, ["onClick"]),
                                _createVNode("a", {
                                  href: "javascript:void(0)",
                                  class: "trash",
                                  onClick: ($event: any) => (_ctx.showNewElementDelete(form, 'radioButton'))
                                }, [
                                  _hoisted_57
                                ], 8, ["onClick"])
                              ]),
                              _createVNode("label", _hoisted_58, _toDisplayString(form.title), 1),
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(form.select_values, (option, optionIndex) => {
                                return (_openBlock(), _createBlock("div", {
                                  class: "custom-control custom-radio custom-control-inline",
                                  key: optionIndex
                                }, [
                                  _withDirectives(_createVNode("input", {
                                    disabled: "",
                                    type: "radio",
                                    id: "customRadioInline1",
                                    name: "customRadioInline1",
                                    class: "custom-control-input",
                                    value: option.value,
                                    "onUpdate:modelValue": ($event: any) => (option.selected = $event)
                                  }, null, 8, ["value", "onUpdate:modelValue"]), [
                                    [_vModelRadio, option.selected]
                                  ]),
                                  _createVNode("label", _hoisted_59, _toDisplayString(option.text), 1)
                                ]))
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (form.type === 'single_select')
                        ? (_openBlock(), _createBlock("div", _hoisted_60, [
                            _createVNode("div", _hoisted_61, [
                              _createVNode("a", {
                                href: "javascript:void(0)",
                                "data-toggle": "modal",
                                onClick: ($event: any) => (_ctx.showNewElementEdit(form, 'single_select'))
                              }, [
                                _hoisted_62
                              ], 8, ["onClick"]),
                              _createVNode("a", {
                                href: "javascript:void(0)",
                                class: "trash",
                                onClick: ($event: any) => (_ctx.showNewElementDelete(form, 'single_select'))
                              }, [
                                _hoisted_63
                              ], 8, ["onClick"])
                            ]),
                            _createVNode("label", _hoisted_64, _toDisplayString(form.title), 1),
                            _createVNode("select", _hoisted_65, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(form.select_values, (option, optionIndex) => {
                                return (_openBlock(), _createBlock("option", {
                                  value: option.value,
                                  key: optionIndex
                                }, _toDisplayString(option.text), 9, ["value"]))
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128)),
                _createVNode("div", _hoisted_66, [
                  _createVNode("button", {
                    class: "btn default-btn",
                    onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.createFormTemplate && _ctx.createFormTemplate(...args)))
                  }, _toDisplayString(_ctx.state.ui.isPostLoading.createFormTemplate
                    ? "Creating..."
                    : "Create Form"), 1)
                ])
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_67, [
                _hoisted_68
              ]))
        ])
      ])
    ]),
    _createVNode("div", _hoisted_69, [
      _createVNode("div", _hoisted_70, [
        _createVNode("div", _hoisted_71, [
          _createVNode("div", _hoisted_72, [
            _createVNode("div", _hoisted_73, [
              _createVNode("h5", _hoisted_74, " Add " + _toDisplayString(_ctx.state.selected), 1),
              _hoisted_75
            ]),
            _createVNode("div", _hoisted_76, [
              _createVNode("div", _hoisted_77, [
                (_ctx.state.type === 'title')
                  ? (_openBlock(), _createBlock("div", _hoisted_78, [
                      _createVNode("div", _hoisted_79, [
                        _hoisted_80,
                        _withDirectives(_createVNode("input", {
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.state.form.textField.title = $event)),
                          type: "text",
                          class: "form-control",
                          id: "inputPassword",
                          placeholder: "Title Here"
                        }, null, 512), [
                          [_vModelText, _ctx.state.form.textField.title]
                        ])
                      ]),
                      _createVNode("div", _hoisted_81, [
                        _hoisted_82,
                        _withDirectives(_createVNode("input", {
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.state.form.textField.description = $event)),
                          type: "text",
                          class: "form-control",
                          id: "inputPassword",
                          placeholder: "Description here"
                        }, null, 512), [
                          [_vModelText, _ctx.state.form.textField.description]
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.state.type === 'textbox')
                  ? (_openBlock(), _createBlock("div", _hoisted_83, [
                      _createVNode("div", _hoisted_84, [
                        _hoisted_85,
                        _withDirectives(_createVNode("input", {
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.state.form.textbox.title = $event)),
                          type: "text",
                          class: "form-control",
                          id: "inputPassword",
                          placeholder: "Title Here"
                        }, null, 512), [
                          [_vModelText, _ctx.state.form.textbox.title]
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.state.type === 'textArea')
                  ? (_openBlock(), _createBlock("div", _hoisted_86, [
                      _createVNode("div", _hoisted_87, [
                        _hoisted_88,
                        _withDirectives(_createVNode("input", {
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.state.form.textArea.title = $event)),
                          type: "text",
                          class: "form-control",
                          id: "inputPassword",
                          placeholder: "Title Here"
                        }, null, 512), [
                          [_vModelText, _ctx.state.form.textArea.title]
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.state.type === 'radioButton')
                  ? (_openBlock(), _createBlock("div", _hoisted_89, [
                      _createVNode("div", _hoisted_90, [
                        _createVNode("div", _hoisted_91, [
                          _hoisted_92,
                          _withDirectives(_createVNode("input", {
                            type: "text",
                            class: "form-control",
                            id: "inputPassword",
                            placeholder: "Text field label",
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.state.form.radioButton.title = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.state.form.radioButton.title]
                          ])
                        ]),
                        (
                        _ctx.state.form.radioButton.select_values &&
                          _ctx.state.form.radioButton.select_values.length
                      )
                          ? (_openBlock(), _createBlock("div", _hoisted_93, [
                              _hoisted_94,
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.form.radioButton
                          .select_values, (row, rowIndex) => {
                                return (_openBlock(), _createBlock("div", {
                                  class: "row py-2",
                                  key: rowIndex
                                }, [
                                  _createVNode("div", _hoisted_95, [
                                    _createVNode("div", _hoisted_96, [
                                      _withDirectives(_createVNode("input", {
                                        class: "form-check-input",
                                        type: "radio",
                                        name: "exampleRadios",
                                        id: "exampleRadios1",
                                        "onUpdate:modelValue": ($event: any) => (row.selected = $event)
                                      }, null, 8, ["onUpdate:modelValue"]), [
                                        [_vModelRadio, row.selected]
                                      ])
                                    ])
                                  ]),
                                  _createVNode("div", _hoisted_97, [
                                    _withDirectives(_createVNode("input", {
                                      type: "text",
                                      class: "form-control",
                                      placeholder: "Option label",
                                      "onUpdate:modelValue": ($event: any) => (row.text = $event)
                                    }, null, 8, ["onUpdate:modelValue"]), [
                                      [_vModelText, row.text]
                                    ])
                                  ]),
                                  _createVNode("div", _hoisted_98, [
                                    _withDirectives(_createVNode("input", {
                                      type: "text",
                                      class: "form-control",
                                      placeholder: "Option value",
                                      "onUpdate:modelValue": ($event: any) => (row.value = $event)
                                    }, null, 8, ["onUpdate:modelValue"]), [
                                      [_vModelText, row.value]
                                    ])
                                  ]),
                                  _createVNode("div", _hoisted_99, [
                                    _createVNode("button", {
                                      type: "button",
                                      class: "option-btn",
                                      onClick: ($event: any) => (_ctx.removeOptions(row.text))
                                    }, [
                                      _hoisted_100
                                    ], 8, ["onClick"])
                                  ])
                                ]))
                              }), 128)),
                              _createVNode("div", _hoisted_101, [
                                _createVNode("a", {
                                  href: "javascript:void(0)",
                                  onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.addOptions && _ctx.addOptions(...args))),
                                  class: "btn default-btn outline secondary mt-3"
                                }, [
                                  _hoisted_102,
                                  _hoisted_103
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.state.type === 'single_select')
                  ? (_openBlock(), _createBlock("div", _hoisted_104, [
                      _createVNode("div", _hoisted_105, [
                        _createVNode("div", _hoisted_106, [
                          _hoisted_107,
                          _withDirectives(_createVNode("input", {
                            type: "text",
                            class: "form-control",
                            id: "inputPassword",
                            placeholder: "Text field label",
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.state.form.selectOption.title = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.state.form.selectOption.title]
                          ])
                        ]),
                        (
                        _ctx.state.form.selectOption.select_values &&
                          _ctx.state.form.selectOption.select_values.length
                      )
                          ? (_openBlock(), _createBlock("div", _hoisted_108, [
                              _hoisted_109,
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.form.selectOption
                          .select_values, (row, rowIndex) => {
                                return (_openBlock(), _createBlock("div", {
                                  class: "row py-2",
                                  key: rowIndex
                                }, [
                                  _createVNode("div", _hoisted_110, [
                                    _createVNode("div", _hoisted_111, [
                                      _withDirectives(_createVNode("input", {
                                        class: "form-check-input",
                                        type: "radio",
                                        name: "exampleRadios",
                                        id: "exampleRadios1",
                                        "onUpdate:modelValue": ($event: any) => (row.selected = $event)
                                      }, null, 8, ["onUpdate:modelValue"]), [
                                        [_vModelRadio, row.selected]
                                      ])
                                    ])
                                  ]),
                                  _createVNode("div", _hoisted_112, [
                                    _withDirectives(_createVNode("input", {
                                      type: "text",
                                      class: "form-control",
                                      placeholder: "Option label",
                                      "onUpdate:modelValue": ($event: any) => (row.text = $event)
                                    }, null, 8, ["onUpdate:modelValue"]), [
                                      [_vModelText, row.text]
                                    ])
                                  ]),
                                  _createVNode("div", _hoisted_113, [
                                    _withDirectives(_createVNode("input", {
                                      type: "text",
                                      class: "form-control",
                                      placeholder: "Option value",
                                      "onUpdate:modelValue": ($event: any) => (row.value = $event)
                                    }, null, 8, ["onUpdate:modelValue"]), [
                                      [_vModelText, row.value]
                                    ])
                                  ]),
                                  _createVNode("div", _hoisted_114, [
                                    _createVNode("button", {
                                      type: "button",
                                      class: "option-btn",
                                      onClick: ($event: any) => (_ctx.removeSelectOption(row.text))
                                    }, [
                                      _hoisted_115
                                    ], 8, ["onClick"])
                                  ])
                                ]))
                              }), 128)),
                              _createVNode("div", _hoisted_116, [
                                _createVNode("a", {
                                  href: "javascript:void(0)",
                                  onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.addSelectOptions && _ctx.addSelectOptions(...args))),
                                  class: "btn default-btn outline secondary mt-3"
                                }, [
                                  _hoisted_117,
                                  _hoisted_118
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.state.type === 'checkBox')
                  ? (_openBlock(), _createBlock("div", _hoisted_119, [
                      _createVNode("div", _hoisted_120, [
                        _createVNode("div", _hoisted_121, [
                          _hoisted_122,
                          _withDirectives(_createVNode("input", {
                            type: "text",
                            class: "form-control",
                            id: "inputPassword",
                            placeholder: "Text field label",
                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.state.form.checkBox.title = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.state.form.checkBox.title]
                          ])
                        ]),
                        (
                        _ctx.state.form.checkBox.select_values &&
                          _ctx.state.form.checkBox.select_values.length
                      )
                          ? (_openBlock(), _createBlock("div", _hoisted_123, [
                              _hoisted_124,
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.form.checkBox
                          .select_values, (row, rowIndex) => {
                                return (_openBlock(), _createBlock("div", {
                                  class: "row py-2",
                                  key: rowIndex
                                }, [
                                  _createVNode("div", _hoisted_125, [
                                    _createVNode("div", _hoisted_126, [
                                      _withDirectives(_createVNode("input", {
                                        class: "form-check-input",
                                        type: "radio",
                                        name: "exampleRadios",
                                        id: "exampleRadios1",
                                        "onUpdate:modelValue": ($event: any) => (row.selected = $event)
                                      }, null, 8, ["onUpdate:modelValue"]), [
                                        [_vModelRadio, row.selected]
                                      ])
                                    ])
                                  ]),
                                  _createVNode("div", _hoisted_127, [
                                    _withDirectives(_createVNode("input", {
                                      type: "text",
                                      class: "form-control",
                                      placeholder: "Option label",
                                      "onUpdate:modelValue": ($event: any) => (row.text = $event)
                                    }, null, 8, ["onUpdate:modelValue"]), [
                                      [_vModelText, row.text]
                                    ])
                                  ]),
                                  _createVNode("div", _hoisted_128, [
                                    _withDirectives(_createVNode("input", {
                                      type: "text",
                                      class: "form-control",
                                      placeholder: "Option value",
                                      "onUpdate:modelValue": ($event: any) => (row.value = $event)
                                    }, null, 8, ["onUpdate:modelValue"]), [
                                      [_vModelText, row.value]
                                    ])
                                  ]),
                                  _createVNode("div", _hoisted_129, [
                                    _createVNode("button", {
                                      type: "button",
                                      class: "option-btn",
                                      onClick: ($event: any) => (_ctx.removeCheckBox(row.text))
                                    }, [
                                      _hoisted_130
                                    ], 8, ["onClick"])
                                  ])
                                ]))
                              }), 128)),
                              _createVNode("div", _hoisted_131, [
                                _createVNode("a", {
                                  href: "javascript:void(0)",
                                  onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.addCheckBox && _ctx.addCheckBox(...args))),
                                  class: "btn default-btn outline secondary mt-3"
                                }, [
                                  _hoisted_132,
                                  _hoisted_133
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_134, [
                  _hoisted_135,
                  _withDirectives(_createVNode("select", {
                    class: "form-control custom-select",
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.state.typePosition = $event))
                  }, [
                    _hoisted_136,
                    _hoisted_137,
                    _hoisted_138
                  ], 512), [
                    [_vModelSelect, _ctx.state.typePosition]
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_139, [
              _hoisted_140,
              _createVNode("button", {
                type: "button",
                class: "btn default-btn",
                onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.addTextField && _ctx.addTextField(...args)))
              }, " Add ")
            ])
          ])
        ])
      ])
    ]),
    _hoisted_141,
    _createVNode("div", _hoisted_142, [
      _createVNode("div", _hoisted_143, [
        _createVNode("div", _hoisted_144, [
          _createVNode("div", _hoisted_145, [
            _createVNode("div", _hoisted_146, [
              _hoisted_147,
              _createVNode("button", {
                type: "button",
                class: "close",
                onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.hideDeleteSelectedElementInCreateNew && _ctx.hideDeleteSelectedElementInCreateNew(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_148
              ])
            ]),
            _hoisted_149,
            _createVNode("div", _hoisted_150, [
              _createVNode("button", {
                type: "button",
                class: "btn secondary-btn",
                onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.hideDeleteSelectedElementInCreateNew && _ctx.hideDeleteSelectedElementInCreateNew(...args)))
              }, " No "),
              _createVNode("button", {
                type: "button",
                class: "btn default-btn",
                onClick: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.deleteSelectedElementOfCreateForm && _ctx.deleteSelectedElementOfCreateForm(...args)))
              }, " Yes ")
            ])
          ])
        ])
      ])
    ])
  ]))
}